import { configureStore } from '@reduxjs/toolkit'
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { contactApiRedux } from './api/contact_api'
import { logApiRedux } from './api/log_api'
import { milestoneApiRedux } from './api/milestone_api'
import { noteApiRedux } from './api/note_api'
import { projectApiRedux } from './api/projects_api'
import { roleApiRedux } from './api/role_api'
import { taskApiRedux } from './api/task_api'
import { rootReducer } from './rootReducer'
import { organizationApiRedux } from './api/organization_api'
import { meetingApiRedux } from './api/meeting_api'
import { timelineApiRedux } from './api/timeline_api'
import { reportApiRedux } from './api/report_api'
import { dashboardApiRedux } from './api/dashboard_api'
import { progressReportApiRedux } from './api/progressReport_api'
import { profileApiRedux } from './api/profile_api'
import { teamApiRedux } from './api/team_api'
import { clientApiRedux } from './api/client_api'
import { accountantApiRedux } from './api/accountant_api'
import { userAdminApiRedux } from './api/admin/user'
import { organizationAdminApiRedux } from './api/admin/organization'
import { projectAdminApiRedux } from './api/admin/project'
import { AttachmentApiRedux } from './api/attachment_api'
import { categoryApiRedux } from './api/category_api'

const persistConfig = {
	key: 'root',
	version: 1,
	storage,
	blacklist: [
		taskApiRedux.reducerPath,
		logApiRedux.reducerPath,
		projectApiRedux.reducerPath,
		noteApiRedux.reducerPath,
		milestoneApiRedux.reducerPath,
		contactApiRedux.reducerPath,
		roleApiRedux.reducerPath,
		organizationApiRedux.reducerPath,
		meetingApiRedux.reducerPath,
		timelineApiRedux.reducerPath,
		reportApiRedux.reducerPath,
		dashboardApiRedux.reducerPath,
		progressReportApiRedux.reducerPath,
		profileApiRedux.reducerPath,
		teamApiRedux.reducerPath,
		clientApiRedux.reducerPath,
		accountantApiRedux.reducerPath,
		userAdminApiRedux.reducerPath,
		organizationAdminApiRedux.reducerPath,
		projectAdminApiRedux.reducerPath,
		AttachmentApiRedux.reducerPath,
		categoryApiRedux.reducerPath
	]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
	reducer: persistedReducer,
	devTools: process.env.NODE_ENV !== 'production',
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
			}
		}).concat(
			taskApiRedux.middleware,
			projectApiRedux.middleware,
			logApiRedux.middleware,
			noteApiRedux.middleware,
			milestoneApiRedux.middleware,
			contactApiRedux.middleware,
			roleApiRedux.middleware,
			organizationApiRedux.middleware,
			meetingApiRedux.middleware,
			timelineApiRedux.middleware,
			reportApiRedux.middleware,
			dashboardApiRedux.middleware,
			progressReportApiRedux.middleware,
			profileApiRedux.middleware,
			teamApiRedux.middleware,
			clientApiRedux.middleware,
			accountantApiRedux.middleware,
			accountantApiRedux.middleware,
			userAdminApiRedux.middleware,
			organizationAdminApiRedux.middleware,
			projectAdminApiRedux.middleware,
			AttachmentApiRedux.middleware,
			categoryApiRedux.middleware
		)
})

export let persistor = persistStore(store)
